import { Image, Heading3, Body1 } from '@cian/ui-kit';
import { clsx } from 'clsx';
import * as React from 'react';

import * as styles from './BubbleMessage.css';
import { BubbleContent } from '../BubbleContent';
import { TBubbleBody, TMessageBubbleTitle } from '../../types/messageBubble';

interface IBubbleMessageProps {
  title: TMessageBubbleTitle;
  content?: TBubbleBody[] | null;
  buttonsNode: React.ReactNode | null;
  textFieldNode: React.ReactNode | null;
}

export const BubbleMessage = (props: IBubbleMessageProps) => {
  const { title, content, textFieldNode, buttonsNode } = props;
  const { icon, label } = title;

  const hasContent = !!content?.length;
  const LabelTypography = hasContent ? Heading3 : Body1;

  return (
    <div className={clsx(styles['container'], !!icon && styles['container_with_icon'])}>
      {label && (
        <div className={styles['title']} data-name="BubbleMessage_title">
          <LabelTypography>
            {!!icon && (
              <span className={styles['title_icon']}>
                <Image src={icon} alt="Иконка сообщения" width={16} height={16} />
              </span>
            )}
            {label}
          </LabelTypography>
        </div>
      )}

      {!!content?.length && <BubbleContent content={content} />}

      {textFieldNode}

      {buttonsNode && (
        <div
          className={clsx(
            styles['buttons'],
            !!icon && styles['buttons_with_icon'],
            !content && styles['buttons_centered'],
          )}
        >
          {buttonsNode}
        </div>
      )}
    </div>
  );
};
